// import React from "react";
// import { ReactP5Wrapper } from "react-p5-wrapper";

// function grid(p){
//   const GRID_COLOR = [200, 200, 200, 80]; // Light gray with low alpha
//   p.push();
//   p.stroke(...GRID_COLOR);
//   p.strokeWeight(1);
//   let step = 40; // Size of grid squares

//   // Draw grid much larger than canvas so it doesn't "run out" during camera movement
//   let gridSize = 2000;
//   for (let x = -gridSize; x <= gridSize; x += step) {
//       p.line(x, -gridSize, x, gridSize);
//   }
//   for (let y = -gridSize; y <= gridSize; y += step) {
//       p.line(-gridSize, y, gridSize, y);
//   }
//   p.pop();
// }

// const Twolinecharts = ({ p5ref, wt, ht, scale, fs, bgcolor }) => {


//   const sketch = (p) => {
//     // --- Color definitions ---
//     const BLACK = [51, 51, 51];
//     const PINK = [235, 93, 123];
//     const BLUE = [93, 105, 235];
//     const BEIGE = [255, 254, 246];

//     let firstText = 'A soulmate isn’t about checking every box';
//     let secondText = 'but the few that truly matter.';
//     let latoFont = 'Lato'; // Font name reference
//     let feelWidths = [];
//     let doWidths = [];
//     let spaceKerning = 4.75;

//     // --- Animation variables ---
//     let checkboxes = [];
//     let totalBoxes = 5;
//     let boxSize = 30;
//     let spacing = 60;
//     let animIndex = 0;
//     let checkInterval = 30;
//     let expanding = false;

//     // Character-specific extra spacing
//     const letter_extra_space = {
//       'a': 1.05, 'b': 1, 'c': 1, 'd': 1, 'e': 1.5, 'f': 0, 'g': 1, 'h': 1, 'i': 1, 'j': 1,
//       'k': 1, 'l': 0.1, 'm': 1, 'n': 1, 'o': 1, 'p': 1, 'q': 1, 'r': -0.2, 's': 2, 't': 0,
//       'u': 1, 'v': 0, 'w': 1, 'x': 1, 'y': 1, 'z': 1,
//       'A': 1, 'B': 1, 'C': 1, 'D': 1, 'E': 1, 'F': 1, 'G': 1, 'H': 1, 'I': 1, 'J': 1,
//       'K': 1, 'L': 0.5, 'M': 1, 'N': 1, 'O': 1, 'P': 1, 'Q': 1, 'R': 1, 'S': 1, 'T': 1,
//       'U': 1, 'V': 1, 'W': 1, 'X': 1, 'Y': 1, 'Z': 1
//     };

//     // --- Helpers ---
//     function loadGoogleFont() {
//       const link = document.createElement('link');
//       link.href = 'https://fonts.googleapis.com/css2?family=Lato&display=swap';
//       link.rel = 'stylesheet';
//       document.head.appendChild(link);
//     }

//     function setupCheckboxes() {
//       let startY = -((totalBoxes - 1) / 2) * spacing;
//       for (let i = 0; i < totalBoxes; i++) {
//         checkboxes.push({
//           x: 0,
//           y: startY + i * spacing,
//           size: boxSize,
//           checked: false,
//           crossed: false,
//           alpha: 255
//         });
//       }
//     }

//     // --- Setup ---
//     p.setup = () => {
//       loadGoogleFont();
//       // p.createCanvas returns the renderer, used for stream capture
//       let c = p.createCanvas(wt, ht);
//       p.rectMode(p.CENTER);
//       p.ellipseMode(p.CENTER);
//       p.textAlign(p.LEFT, p.CENTER);
//       p.textSize(fs);

//       // Set font (css takes a moment to load, but p5 attempts to use name)
//       p.textFont(latoFont);

//       // Precompute character widths
//       for (let i = 0; i < firstText.length; i++) {
//         let charWidth = p.textWidth(firstText[i]);
//         let extra = (firstText[i] === ' ' ? spaceKerning : (letter_extra_space[firstText[i]] || 0));
//         feelWidths[i] = charWidth + extra;
//       }
//       for (let i = 0; i < secondText.length; i++) {
//         let charWidth = p.textWidth(secondText[i]);
//         let extra = (secondText[i] === ' ' ? spaceKerning : (letter_extra_space[secondText[i]] || 0));
//         doWidths[i] = charWidth + extra;
//       }

//       // Initialize boxes
//       setupCheckboxes();


//     };

//     // --- Main Content Logic ---
//     const maincontent = () => {
//       p.push();
//       p.translate(p.width / 2, p.height / 2.25);

//       // Animate checking one by one
//       if (!expanding && animIndex < totalBoxes) {
//         if (p.frameCount % checkInterval === 0) {
//           if (checkboxes[animIndex]) {
//             checkboxes[animIndex].checked = true;

//             // Only the third box (index 2) is checked, others are crossed
//             if (animIndex === 2) {
//               checkboxes[animIndex].crossed = false;
//             } else {
//               checkboxes[animIndex].crossed = true;
//             }
//             animIndex++;
//           }
//         }
//       }

//       // Start expansion after all checked
//       if (animIndex >= totalBoxes) expanding = true;

//       // Animate expansion and fade/move other boxes
//       if (expanding) {
//         for (let i = 0; i < checkboxes.length; i++) {
//           let cb = checkboxes[i];
//           if (i === 2) {
//             cb.size = p.lerp(cb.size, 100, 0.05); // special box grows
//           } else {
//             let dir = i < 2 ? -1 : 1;
//             cb.y += dir * 2;
//             cb.alpha = p.lerp(cb.alpha, 0, 0.05);
//           }
//         }
//       }

//       // Draw checkboxes
//       for (let i = 0; i < checkboxes.length; i++) {
//         let cb = checkboxes[i];
//         p.push();
//         p.noFill();
//         p.stroke(BLACK[0], BLACK[1], BLACK[2], cb.alpha);
//         p.strokeWeight(2);
//         p.rect(cb.x, cb.y, cb.size, cb.size);

//         // Draw check or cross
//         if (cb.checked) {
//           p.strokeWeight(4);
//           p.stroke(
//             cb.crossed ? BLUE[0] : PINK[0],
//             cb.crossed ? BLUE[1] : PINK[1],
//             cb.crossed ? BLUE[2] : PINK[2],
//             cb.alpha
//           );

//           let offset = cb.size / 4;

//           if (cb.crossed) {
//             // Draw X
//             p.line(cb.x - offset, cb.y - offset, cb.x + offset, cb.y + offset);
//             p.line(cb.x - offset, cb.y + offset, cb.x + offset, cb.y - offset);
//           } else {
//             // Draw check
//             // To make the checkmark look nice centered
//             p.line(cb.x - offset, cb.y, cb.x, cb.y + offset);
//             p.line(cb.x, cb.y + offset, cb.x + offset, cb.y - offset);
//           }
//         }
//         p.pop();
//       }




//       p.pop();
//     };

//     // --- Text Logic ---
//     const statictext = () => {
//       p.push();
//       p.textSize(fs);
//       p.textFont(latoFont);
//       p.textAlign(p.LEFT, p.CENTER);

//       let centerX = p.width / 2;
//       let firstY = p.height - 120;
//       let secondY = firstY + 24;

//       let firstWidth = feelWidths.reduce((sum, w) => sum + w, 0);
//       let secondWidth = doWidths.reduce((sum, w) => sum + w, 0);

//       let firstStartX = centerX - firstWidth / 2;
//       let secondStartX = centerX - secondWidth / 2;

//       p.fill(BLACK[0], BLACK[1], BLACK[2]);

//       let x = firstStartX;
//       for (let i = 0; i < firstText.length; i++) {
//         p.text(firstText[i], x, firstY);
//         x += feelWidths[i];
//       }

//       x = secondStartX;
//       for (let i = 0; i < secondText.length; i++) {
//         p.text(secondText[i], x, secondY);
//         x += doWidths[i];
//       }
//       p.pop();
//     };

//     // --- Draw Loop ---
//     p.draw = () => {
//       p.background(BEIGE);
//       grid(p);
//       maincontent();
//       statictext();
//     };
//   };

//   return <div style={{ backgroundColor: bgcolor }}>
//     <div ref={p5ref} style={{ transform: `scale(${scale})` }}>
//       <ReactP5Wrapper sketch={sketch} />
//     </div>
//   </div>

// };

// export default Twolinecharts






















// import React from "react";
// import { ReactP5Wrapper } from "react-p5-wrapper";

// function grid(p) {
//     const GRID_COLOR = [200, 200, 200, 80]; // Light gray with low alpha
//     p.push();
//     p.stroke(...GRID_COLOR);
//     p.strokeWeight(1);
//     let step = 40; // Size of grid squares

//     // Draw grid much larger than canvas so it doesn't "run out" during camera movement
//     let gridSize = 2000;
//     for (let x = -gridSize; x <= gridSize; x += step) {
//         p.line(x, -gridSize, x, gridSize);
//     }
//     for (let y = -gridSize; y <= gridSize; y += step) {
//         p.line(-gridSize, y, gridSize, y);
//     }
//     p.pop();
// }

// const Twolinecharts = ({ p5ref, wt, ht, scale, fs, bgcolor }) => {


//     const sketch = (p) => {
//         // --- Color definitions ---
//         const BLACK = [51, 51, 51];
//         const PINK = [235, 93, 123];
//         const BLUE = [93, 105, 235];
//         const BEIGE = [255, 254, 246];

//         // let firstText = `When the math of 'I' became the poetry of 'Us'.`;
//         // No longer lost in the chaos; two rhythms, held by a shared reason.
//         let firstText = 'No longer lost in the chaos'
//         let secondText = 'Two rhythms, held by a shared reason.'

//         // 

//         let latoFont = 'Lato'; // Font name reference
//         let feelWidths = [];
//         let doWidths = [];
//         let spaceKerning = 4.75;

//         // --- Animation variables ---
//         let checkboxes = [];
//         let totalBoxes = 5;
//         let boxSize = 30;
//         let spacing = 60;
//         let animIndex = 0;
//         let checkInterval = 30;
//         let expanding = false;

//         // Character-specific extra spacing
//         const letter_extra_space = {
//             'a': 1.05, 'b': 1, 'c': 1, 'd': 1, 'e': 1.5, 'f': 0, 'g': 1, 'h': 1, 'i': 1, 'j': 1,
//             'k': 1, 'l': 0.1, 'm': 1, 'n': 1, 'o': 1, 'p': 1, 'q': 1, 'r': -0.2, 's': 2, 't': 0,
//             'u': 1, 'v': 0, 'w': 1, 'x': 1, 'y': 1, 'z': 1,
//             'A': 1, 'B': 1, 'C': 1, 'D': 1, 'E': 1, 'F': 1, 'G': 1, 'H': 1, 'I': 1, 'J': 1,
//             'K': 1, 'L': 0.5, 'M': 1, 'N': 1, 'O': 1, 'P': 1, 'Q': 1, 'R': 1, 'S': 1, 'T': 1,
//             'U': 1, 'V': 1, 'W': 1, 'X': 1, 'Y': 1, 'Z': 1
//         };

//         // --- Helpers ---
//         function loadGoogleFont() {
//             const link = document.createElement('link');
//             link.href = 'https://fonts.googleapis.com/css2?family=Lato&display=swap';
//             link.rel = 'stylesheet';
//             document.head.appendChild(link);
//         }

//         function setupCheckboxes() {
//             let startY = -((totalBoxes - 1) / 2) * spacing;
//             for (let i = 0; i < totalBoxes; i++) {
//                 checkboxes.push({
//                     x: 0,
//                     y: startY + i * spacing,
//                     size: boxSize,
//                     checked: false,
//                     crossed: false,
//                     alpha: 255
//                 });
//             }
//         }

//         // --- Setup ---
//         p.setup = () => {
//             loadGoogleFont();
//             // p.createCanvas returns the renderer, used for stream capture
//             let c = p.createCanvas(wt, ht);
//             p.rectMode(p.CENTER);
//             p.ellipseMode(p.CENTER);
//             p.textAlign(p.LEFT, p.CENTER);
//             p.textSize(fs);

//             // Set font (css takes a moment to load, but p5 attempts to use name)
//             p.textFont(latoFont);

//             // Precompute character widths
//             for (let i = 0; i < firstText.length; i++) {
//                 let charWidth = p.textWidth(firstText[i]);
//                 let extra = (firstText[i] === ' ' ? spaceKerning : (letter_extra_space[firstText[i]] || 0));
//                 feelWidths[i] = charWidth + extra;
//             }
//             for (let i = 0; i < secondText.length; i++) {
//                 let charWidth = p.textWidth(secondText[i]);
//                 let extra = (secondText[i] === ' ' ? spaceKerning : (letter_extra_space[secondText[i]] || 0));
//                 doWidths[i] = charWidth + extra;
//               }

//             // Initialize boxes
//             setupCheckboxes();


//         };





//        // --- Animation variables ---
//        let points = [];
//        let maxPoints = 80; 
//        let timeVal = 0; 
//        const FPS = 60; 

//        const maincontent = () => {
//            p.push();
//            p.translate(p.width / 2 - (maxPoints * 7) / 2, p.height / 2.25);

//            timeVal += 0.04;
//            let frames = p.frameCount;

//            // 1. Timing milestones
//            // 0-3s: Separate lives (No crossing)
//            // 3-6s: The meeting / Falling in love (Closing the gap)
//            // 6s+: Moving together in sync
//            let alignStart = 3 * FPS;
//            let alignEnd = 6 * FPS;
//            let alignT = p.constrain(p.map(frames, alignStart, alignEnd, 0, 1), 0, 1);

//            // 2. The Individual Noises (The "Highs and Lows")
//            let noiseA = p.noise(timeVal) * 80 - 40;         
//            let noiseB = p.noise(timeVal + 1000) * 80 - 40;   

//            // 3. The Math Logic: Ensuring no crossing before 3s
//            // We give them a massive starting gap (120px) so they never touch.
//            // As alignT increases, this gap shrinks to a constant 20px.
//            const initialGap = 120;
//            const finalGap = 20; 
//            let currentGap = p.lerp(initialGap, finalGap, alignT);

//            // 4. The "Falling in Love" Sync
//            // This forces noiseB to abandon its old rhythm and adopt noiseA's rhythm.
//            let synchronizedNoiseB = p.lerp(noiseB, noiseA, alignT);

//            // 5. Calculate Y positions
//            // Line 1 stays in its lane, Line 2 moves from its own world into Line 1's rhythm
//            let y1 = noiseA - (currentGap / 2);
//            let y2 = synchronizedNoiseB + (currentGap / 2);

//            points.push({ y1, y2 });
//            if (points.length > maxPoints) points.shift();

//            // 6. DRAWING
//            p.noFill();
//            p.strokeWeight(2.5);

//            // Line A (The first life)
//            p.stroke(BLUE[0], BLUE[1], BLUE[2], 220);
//            p.beginShape();
//            points.forEach((pt, i) => p.vertex(i * 7, pt.y1));
//            p.endShape();

//            // Line B (The second life)
//            p.stroke(PINK[0], PINK[1], PINK[2], 220);
//            p.beginShape();
//            points.forEach((pt, i) => p.vertex(i * 7, pt.y2));
//            p.endShape();

//            p.pop();
//        };


//         // --- Main Content Logic ---
//         const maincontent_old = () => {
//             p.push();
//             p.translate(p.width / 2, p.height / 2.25);

//             // im using "react-p5-wrapper": "^3.0.2",
//             // help me generate graph, with two line moving in two different y coord, howver after awhile they meet, they converge.




//             p.pop();
//         };

//         // --- Text Logic ---
//         const statictext = () => {
//             p.push();
//             p.textSize(fs);
//             p.textFont(latoFont);
//             p.textAlign(p.LEFT, p.CENTER);

//             let centerX = p.width / 2;
//             let firstY = p.height - 120;
//             let secondY = firstY + 24;

//             let firstWidth = feelWidths.reduce((sum, w) => sum + w, 0);
//             let secondWidth = doWidths.reduce((sum, w) => sum + w, 0);

//             let firstStartX = centerX - firstWidth / 2;
//             let secondStartX = centerX - secondWidth / 2;

//             p.fill(BLACK[0], BLACK[1], BLACK[2]);

//             let x = firstStartX;
//             for (let i = 0; i < firstText.length; i++) {
//                 p.text(firstText[i], x, firstY);
//                 x += feelWidths[i];
//             }

//             x = secondStartX;
//             for (let i = 0; i < secondText.length; i++) {
//               p.text(secondText[i], x, secondY);
//               x += doWidths[i];
//             }

//             p.pop();
//         };

//         // --- Draw Loop ---
//         p.draw = () => {
//             p.background(BEIGE);
//             grid(p);
//             maincontent();
//             statictext();
//         };
//     };

//     return <div style={{ backgroundColor: bgcolor }}>
//         <div ref={p5ref} style={{ transform: `scale(${scale})` }}>
//             <ReactP5Wrapper sketch={sketch} />
//         </div>
//     </div>

// };

// export default Twolinecharts




import React from "react";
import { ReactP5Wrapper } from "react-p5-wrapper";

function grid(p) {
    const GRID_COLOR = [200, 200, 200, 80];
    p.push();
    p.stroke(...GRID_COLOR);
    p.strokeWeight(1);
    let step = 40;
    let gridSize = 2000;
    for (let x = -gridSize; x <= gridSize; x += step) {
        p.line(x, -gridSize, x, gridSize);
    }
    for (let y = -gridSize; y <= gridSize; y += step) {
        p.line(-gridSize, y, gridSize, y);
    }
    p.pop();
}

const Twolinecharts = ({ p5ref, wt, ht, scale, fs, bgcolor }) => {

    const sketch = (p) => {
        // --- Color definitions ---
        const DEEP_BLACK = [15, 15, 15];
        const PINK = [235, 93, 123];
        const BLUE = [93, 105, 235];
        const BEIGE = [255, 254, 246];


        let firstText = 'No longer lost in the chaos,';
        let secondText = 'two rhythms finding a shared reason.';

        let latoFont = 'Lato';
        let feelWidths = [];
        let doWidths = [];
        let spaceKerning = 4.75;

        let points = [];
        let maxPoints = 80;
        let timeVal = 0;
        const FPS = 60;

        let numExtras = 20;
        let extraOffsets = [];

        function loadGoogleFont() {
            const link = document.createElement('link');
            link.href = 'https://fonts.googleapis.com/css2?family=Lato&display=swap';
            link.rel = 'stylesheet';
            document.head.appendChild(link);
        }

        p.setup = () => {
            loadGoogleFont();
            p.createCanvas(wt, ht);
            p.textAlign(p.LEFT, p.CENTER);
            p.textSize(fs);
            p.textFont(latoFont);

            for (let i = 0; i < numExtras; i++) {
                extraOffsets.push({
                    seed: p.random(1000, 50000),
                    yOffset: p.random(-200, 200),
                    amplitude: p.random(60, 150)
                });
            }

            for (let i = 0; i < firstText.length; i++) {
                feelWidths[i] = p.textWidth(firstText[i]) + (firstText[i] === ' ' ? spaceKerning : 0);
            }
            for (let i = 0; i < secondText.length; i++) {
                doWidths[i] = p.textWidth(secondText[i]) + (secondText[i] === ' ' ? spaceKerning : 0);
            }
        };

        const maincontent = () => {
            p.push();
            p.translate(p.width / 2 - (maxPoints * 7) / 2, p.height / 2.25);

            timeVal += 0.04;
            let frames = p.frameCount;

            // Interaction logic based on alignT (0 to 1)
            let alignStart = 3 * FPS;
            let alignEnd = 7 * FPS;
            let alignT = p.constrain(p.map(frames, alignStart, alignEnd, 0, 1), 0, 1);

            // 1. Noise Calculations
            let noiseA = p.noise(timeVal) * 80 - 40;
            let noiseB = p.noise(timeVal + 1000) * 80 - 40;

            const initialGap = 130;
            const finalGap = 24;
            let currentGap = p.lerp(initialGap, finalGap, alignT);
            let syncB = p.lerp(noiseB, noiseA, alignT);

            let currentExtraY = extraOffsets.map(ex => {
                return (p.noise(timeVal + ex.seed) * ex.amplitude) - (ex.amplitude / 2) + ex.yOffset;
            });

            points.push({
                y1: noiseA - (currentGap / 2),
                y2: syncB + (currentGap / 2),
                extras: currentExtraY
            });
            if (points.length > maxPoints) points.shift();

            // 2. Dynamic Values based on Sync (alignT)
            let currentWeight = p.lerp(1, 4, alignT); // Weight goes 1 -> 4
            let extraAlpha = p.lerp(220, 100, alignT); // Extras dim 100 -> 20

            let baseBlack = p.color(DEEP_BLACK[0], DEEP_BLACK[1], DEEP_BLACK[2], 220);
            let targetBlue = p.color(BLUE[0], BLUE[1], BLUE[2], 220);
            let targetPink = p.color(PINK[0], PINK[1], PINK[2], 220);

            let currentBlue = p.lerpColor(baseBlack, targetBlue, alignT);
            let currentPink = p.lerpColor(baseBlack, targetPink, alignT);

            p.noFill();

            // 3. Draw Extra Lines (Dimming down)
            p.strokeWeight(1);
            p.stroke(DEEP_BLACK[0], DEEP_BLACK[1], DEEP_BLACK[2], extraAlpha);
            for (let j = 0; j < numExtras; j++) {
                p.beginShape();
                points.forEach((pt, i) => {
                    p.vertex(i * 7, pt.extras[j]);
                });
                p.endShape();
            }

            // 4. Draw Main Lines (Growing thicker and colorful)
            p.strokeWeight(currentWeight);

            // Blue line
            p.stroke(currentBlue);
            p.beginShape();
            points.forEach((pt, i) => p.vertex(i * 7, pt.y1));
            p.endShape();

            // Pink line
            p.stroke(currentPink);
            p.beginShape();
            points.forEach((pt, i) => p.vertex(i * 7, pt.y2));
            p.endShape();

            p.pop();
        };

        const statictext = () => {
            p.push();
            p.textSize(fs);
            p.textFont(latoFont);
            p.fill(...DEEP_BLACK);

            let firstWidth = feelWidths.reduce((a, b) => a + b, 0);
            let secondWidth = doWidths.reduce((a, b) => a + b, 0);

            let x1 = p.width / 2 - firstWidth / 2;
            for (let i = 0; i < firstText.length; i++) {
                p.text(firstText[i], x1, p.height - 120);
                x1 += feelWidths[i];
            }

            let x2 = p.width / 2 - secondWidth / 2;
            for (let i = 0; i < secondText.length; i++) {
                p.text(secondText[i], x2, p.height - 92);
                x2 += doWidths[i];
            }
            p.pop();
        };

        p.draw = () => {
            p.background(BEIGE);
            grid(p);
            maincontent();
            statictext();
        };
    };

    return (
        <div style={{ backgroundColor: bgcolor }}>
            <div ref={p5ref} style={{ transform: `scale(${scale})` }}>
                <ReactP5Wrapper sketch={sketch} />
            </div>
        </div>
    );
};

export default Twolinecharts;